<template>
	<v-card class="mt-4">
		<div class="d-flex align-center pa-3 gap-2">
			<v-btn
					v-if="backButton"
					class="flex-grow-0"
					icon
					@click="$emit('back')"
			>
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>

			<v-card-title class="flex-grow-1 pa-0">
				{{ $t("pages.preferences.title") }}
			</v-card-title>
		</div>

		<v-list class="pt-0">
			<v-list-item
					v-for="(item, i) in items"
					:key="`item-${i}`"
					:to="item.to"
			>
				<v-list-item-icon class="mr-4">
					<v-icon v-html="item.icon" />
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>
						{{ $t(`pages.preferences.${item.title}.title`) }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-card>
</template>

<script>
export default {
  props: {
    backButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      items: [
        {
          title: "account",
          icon: "mdi-account-cog",
          to: { name: "account-preferences" },
        },
        {
          title: "signInAndSecurity",
          icon: "mdi-lock",
          to: { name: "sign-in-and-security-preferences" },
        },
        {
          title: "logout",
          icon: "mdi-logout-variant",
          to: { name: "logout" },
        },
      ],
    };
  },
};
</script>
